module.exports = __webpack_public_path__ + "static/PilotFBO_whitebackground-c42e2dba11fe9600f45e903144a5eb6b.png";